import React from 'react';
import Hero from './components/activities/Hero';
import Main from './components/activities/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const Activities = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default Activities;